export default {
  getIamViolationCount: state => state.totalCount,
  getIamViolation: state => state.gridData,
  getSearchParamIamViolation: state => state.searchParam,
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/security/violations/IamViolationGetter.js